import { useLingui } from "@lingui/react";
import { formatDate } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const FirstRegistration = ({ firstRegistration }: SpecProps<"first_registration">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (firstRegistration == null || firstRegistration === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.first_registration",
    message: "First registration",
    comment: "Field for 'first registration' in ad specification",
  });
  const value = formatDate(firstRegistration, locale);
  return <FieldValuePair field={field} value={value} suppressHydrationWarning />;
};
